var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.317 16.433a.629.629 0 0 1-.009.875.618.618 0 0 1-.441.184.618.618 0 0 1-.442-.184l-3.642-3.641a6.284 6.284 0 0 1-3.991 1.425 6.285 6.285 0 0 1-5.748-3.725 6.305 6.305 0 0 1 1.298-7.025 6.302 6.302 0 0 1 8.908 0 6.313 6.313 0 0 1 .417 8.441l3.641 3.642a.642.642 0 0 1 .009.008ZM4.449 11.367c.21.354.465.687.768.991l.004.005.004.004h-.008l.004.004.004.004a5.058 5.058 0 0 0 7.133-.008 5.06 5.06 0 0 0 0-7.142A5.028 5.028 0 0 0 8.793 3.75a5.028 5.028 0 0 0-3.567 1.475 5.064 5.064 0 0 0-.776 6.142Z",
    fill: "current"
  })));
};
export default SvgSearch;